export default __webpack_public_path__ + "static/media/qrscananimation.9778e54e.gif";